module.exports = __webpack_public_path__ + "static/media/35-4.e731247e.mp3";